<script setup lang="ts">
import { SuggestionsBlockProps } from "./SuggestionsBlock.props"

defineProps<SuggestionsBlockProps>()
</script>

<template>
  <ProductBlocksBrandsGridCardsBlock
    :title="title"
    :cards="cards"
    :hasMultipleRows="true"
  />
</template>
